import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { getUtm } from "@/lib/utm";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function InquiryForm({ projectId, projectName, compact = false }) {
  const { user } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "",
    phone: user?.phone || "",
    email: user?.email || "",
    message: "",
    bhk_preference: "",
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("Name and phone are required.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/leads", { ...form, ...getUtm(), project_id: projectId, project_name: projectName, source: "website" });
      toast.success("Thanks! Our team will reach out within 30 minutes.");
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid="inquiry-form-success"
        className="rounded-xl border border-forest/20 bg-forest/5 p-6 text-forest"
      >
        <div className="font-heading font-bold text-lg mb-1">Request received</div>
        <p className="text-sm">A relationship manager will call you shortly. You can also chat with us on WhatsApp for a faster response.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={`space-y-3 ${compact ? "" : "bg-white border border-border rounded-xl p-6"}`} data-testid="inquiry-form">
      {!compact && (
        <div>
          <div className="font-heading font-bold text-xl text-forest">Talk to our team</div>
          <p className="text-xs text-muted-foreground mt-1">We respond within 30 mins · Mon–Sun · 9am–9pm</p>
        </div>
      )}
      <div>
        <Label htmlFor="i-name" className="text-xs">Full name</Label>
        <Input id="i-name" data-testid="inquiry-name" value={form.name} onChange={(e) => upd("name", e.target.value)} placeholder="Your name" />
      </div>
      <div>
        <Label htmlFor="i-phone" className="text-xs">Phone</Label>
        <Input id="i-phone" data-testid="inquiry-phone" value={form.phone} onChange={(e) => upd("phone", e.target.value)} placeholder="+91 …" />
      </div>
      <div>
        <Label htmlFor="i-email" className="text-xs">Email (optional)</Label>
        <Input id="i-email" type="email" data-testid="inquiry-email" value={form.email} onChange={(e) => upd("email", e.target.value)} />
      </div>
      <div>
        <Label htmlFor="i-msg" className="text-xs">Message</Label>
        <Textarea id="i-msg" rows={3} data-testid="inquiry-message" value={form.message} onChange={(e) => upd("message", e.target.value)} placeholder="e.g. Looking for 2BHK under 70L in Kompally" />
      </div>
      <Button
        type="submit"
        disabled={loading}
        data-testid="inquiry-submit"
        className="w-full bg-forest hover:bg-forest-hover text-white h-11 rounded-full"
      >
        {loading ? "Sending…" : "Request a Callback"}
      </Button>
      <p className="text-[11px] text-muted-foreground text-center">By submitting you agree to receive calls/WhatsApp from Our First Realty.</p>
    </form>
  );
}
